import { render, staticRenderFns } from "./_menu.vue?vue&type=template&id=56f35564&"
import script from "./_menu.vue?vue&type=script&lang=js&"
export * from "./_menu.vue?vue&type=script&lang=js&"
import style0 from "./_menu.vue?vue&type=style&index=0&id=56f35564&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports